import audioPlayerView from './audioPlayerComponent.html';
import './audioPlayerComponent.css';

export function audioPlayerComponent() {
	return {
		bindings: {
			src: '<',
			autoplay: '<',
			volume: '<',
			onEnd: '&?',
			onError: '&?',
		},
		controllerAs: 'vm',
		controller: audioPlayerComponentCtrl,
		template: audioPlayerView,
	};
}

export class audioPlayerComponentCtrl {
	constructor($scope, $element, $timeout) {
		'ngInject';
		this.$scope = $scope;
		this.$element = $element;
		this.$timeout = $timeout;
	}

	$onInit() {
		this.audio = this.$element[0].querySelector('audio');
		this.audio.autoplay = this.autoplay;
		this.audio.onerror = $error => {
			this.$timeout(() => {
				this.onError && this.onError({ $error });
			});
		};
		this.audio.onended = $event => {
			this.$timeout(() => {
				this.onEnd && this.onEnd({ $event });
			});
		};
		this.$scope.$watch('vm.src', this._loadSrc.bind(this));
		this.$scope.$watch('vm.volume', this._setVolume.bind(this));
	}

	_loadSrc(src) {
		if (typeof src == 'string') {
			this.audio.src = src;
		}
	}

	_setVolume(volume) {
		if (typeof volume == 'number' && volume >= 0 && volume <= 1) {
			this.audio.volume = newValue;
		}
	}
}
